import { Button } from "components/DesignSystem/Button/Button";
import { OptionData } from "components/DesignSystem/Combobox/Combobox";
import Pencil from "components/icons/pencil";
import { components, OptionProps } from "react-select";

export const SelectOrEditCustomer = ({
  children,
  ...props
}: OptionProps<OptionData>) => {
  return (
    <components.Option
      {...props}
      className="[&.select\_\_option--is-focused]:t-bg-surface-lighter-grey [&.select\_\_option--is-selected]:t-bg-i-surface-light-purple"
    >
      <div className="t-flex t-gap-2.5 t-font-medium t-items-center t-justify-between t-px-3 ">
        <div className="t-cursor-pointer t-truncate !t-border-none t-py-2.5">
          {children}
        </div>
        <Button
          customType="ghost_icon"
          size="small"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            // @ts-ignore
            props.selectProps?.onEditCustomer?.(props.data.value);
          }}
        >
          <Pencil color="currentColor" />
        </Button>
      </div>
    </components.Option>
  );
};
